var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { shiftEntityName } from '../../../../backend/features/shift/shared';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { showFormDialog } from '@juvare/common-form-ui/showFormDialog';
import { handleErrorSnackbar, showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useStorageClient } from '@juvare/platform-sdk-react/ui/hooks';
import EditIconOutlined from '@mui/icons-material/EditOutlined';
import { Button, Typography } from '@mui/material';
import React from 'react';
export const EditPositionQuantityButton = ({ shift, mutateShift, positionId, positionName }) => {
    const { t } = useMissionsTranslation();
    const shiftStorageClient = useStorageClient(shiftEntityName);
    const selectedPosition = shift.data.positions.find((position) => position.positionId === positionId);
    if (!selectedPosition)
        return null;
    const handleEditQuantity = () => {
        showFormDialog({
            title: t('shiftVolunteerManagementWizard.titles.editQuantity', { positionName }),
            submitLabel: t('shiftVolunteerManagementWizard.labels.save'),
            config: {
                type: 'form.number',
                key: 'quantity',
                label: t('shiftVolunteerManagementWizard.labels.quantity'),
                integer: true,
                validate: {
                    min: selectedPosition.quantity,
                    required: true,
                },
            },
            onSubmit: (_a) => __awaiter(void 0, [_a], void 0, function* ({ quantity: newQuantity }) {
                try {
                    const positions = structuredClone(shift.data.positions);
                    yield shiftStorageClient.post({
                        action: 'partial-update',
                        id: shift.id,
                        data: {
                            positions: positions.map((position) => ({
                                positionId: position.positionId,
                                quantity: position.positionId === positionId ? newQuantity : position.quantity,
                            })),
                        },
                    });
                    mutateShift();
                    showAlertSnackbar({
                        type: 'success',
                        message: t('shiftVolunteerManagementWizard.snackbars.saved'),
                        autoHideDuration: 3000,
                        horizontalPosition: 'right',
                    });
                }
                catch (error) {
                    handleErrorSnackbar(error);
                }
            }),
        });
    };
    return (React.createElement(Button, { sx: { p: 0 }, onClick: handleEditQuantity, size: 'small', startIcon: React.createElement(EditIconOutlined, null) },
        React.createElement(Typography, { variant: 'body2', sx: { textTransform: 'capitalize' } }, t('shiftVolunteerManagementWizard.labels.edit'))));
};
